<template>
  <div class="page">
    <div class="header">
      <div class="flex BothSidesAreAligned">
        <div>
          送餐员
          <img
            v-if="false"
            class="header-icon"
            src="../../assets/img/change.png"
            alt=""
          />
        </div>
        <div class="header-territory" @click="areaDetailShow = true">
          负责区域
        </div>
      </div>
      <!-- <div class="flex BothSidesAreAligned">
                <div class="topBtns QRscan flex BothSidesAreAligned" @click="QRFun">
                    <div>
                        <div class="topBtns-title">扫一扫</div>
                        <div class="topBtns-text">取餐/核销</div>
                    </div>
                    <img src="../../assets/img/scan.png" alt="" />
                </div>
                <div class="topBtns DishBtn flex BothSidesAreAligned" @click="XZQRFun">
                    <div>
                        <div class="topBtns-title">协助点餐</div>
                        <div class="topBtns-text">协助客户点餐</div>
                    </div>
                    <img src="../../assets/img/Frame.png" alt="" />
                </div>
            </div> -->
      <div class="flex BothSidesAreAligned content-buts">
        <van-tabs v-model="typeActive" @click="OrderTabChange">
          <van-tab title="新订单" name="AREA" />
          <van-tab title="派送中" name="CURRENT" />
          <van-tab title="已完成" name="HISTORY" />
        </van-tabs>
      </div>
    </div>

    <div class="content">
      <div class="OrderSearch" v-if="typeActive === 'AREA'">
        <div class="Order-List-ReceiveO" @click="orderToReceived([], true)">
          接全部单
        </div>
      </div>
      <div class="OrderSearch" v-if="typeActive === 'HISTORY'">
        <div class="OrderSearch-Time" @click="show = true">
          <div class="OrderSearch-timeSearch">
            {{ date }}
          </div>
        </div>
      </div>

      <div ref="listout">
        <van-list
          ref="orderListRef"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="OrderListFun"
          :offset="100"
          class="Order-List"
        >
          <div
            v-for="(item, index) in orderList"
            :key="index"
            class="flex BothSidesAreAligned Order-List-Item"
          >
            <!-- 未接单 -->
            <div v-if="typeActive === 'AREA'">
              <div>
                <div>
                  电话: {{ item.customerPhone }} 名称: {{ item.customerName }}
                  <br />
                  地址: {{ item.addressDetail }}
                </div>
                <div>
                  档口: {{ item.branchName }} <br />
                  订单号: {{ item.orderNo }}
                </div>
              </div>

              <div
                class="Order-List-ReceiveO"
                @click="orderToReceived([item.orderNo], false)"
              >
                接单
              </div>
            </div>

            <!-- 派送中 -->
            <div v-if="typeActive === 'CURRENT'">
              <div>
                {{ item.customerPhone }} {{ item.customerName }}
                <br />
                {{ item.addressDetail }}
                <div>
                  档口: {{ item.branchName }} <br />
                  订单号: {{ item.orderNo }}
                </div>
              </div>
              <div
                class="Order-List-ReceiveO"
                @click="orderToFinish([item.orderNo])"
              >
                送达
              </div>
            </div>

            <!-- 已完成 -->
            <div v-if="typeActive === 'HISTORY'">
              <div>
                {{ item.customerPhone }} {{ item.customerName }}
                <br />
                <div>接单日期: {{ item.delivererStatusReceivedTime }}</div>
                <div v-if="item.reserveStatus === 10">
                  送达日期: {{ item.delivererStatusFinishTime }}
                </div>
                <div v-else>未送达</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-popup
      v-model="orderDetailShow"
      @click="orderDetailShow = false"
      :lock-scroll="false"
    >
      <div class="oneKeyCon">
        <div class="oneKeyCon-Title">{{ oneKeyConTitle }}</div>
        <div class="oneKeyCon-Con">
          <div class="flex oneKeyCon-Con-item">
            <div style="width: 30%">用餐人</div>
            <div>{{ orderDetail.customerName }}</div>
          </div>
          <div class="flex oneKeyCon-Con-item">
            <div style="width: 30%">详细地址</div>
            <div>{{ orderDetail.address }}</div>
          </div>
          <div class="flex oneKeyCon-Con-item">
            <div style="width: 30%">餐段：</div>
            <div>{{ orderDetail.mealHourName }}</div>
          </div>
          <div class="flex oneKeyCon-Con-item">
            <div style="width: 30%">菜品套餐</div>
            <div>
              <span v-for="(item, index) in orderDetail.items" :key="index">
                {{ item.productName }}
              </span>
            </div>
          </div>
          <div class="flex oneKeyCon-Con-item">
            <div style="width: 30%">医嘱类型</div>
            <div>普食</div>
          </div>
        </div>
        <div class="refundedimg" v-if="orderDetail.status == 'DISPATCH'">
          <img src="../../assets/imgs/refunded_label.png" alt="" />
        </div>
        <div class="overlay-Buts">
          <div
            class="overlay-Buts-Over"
            style="margin: 0 auto"
            @click.stop="orderDetailShow = false"
          >
            我知道了
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="areaDetailShow"
      @click="areaDetailShow = false"
      :lock-scroll="false"
    >
      <div class="oneKeyCon">
        <div class="oneKeyCon-Title">当前负责区域</div>
        <div class="oneKeyCon-Con">
          <div v-for="(item, index) in categoryList" :key="index">
            <div>{{ item.pathName }}</div>
          </div>
        </div>
        <div class="overlay-Buts">
          <div
            class="overlay-Buts-Over"
            style="margin: 0 auto"
            @click.stop="areaDetailShow = false"
          >
            我知道了
          </div>
        </div>
      </div>
    </van-popup>
    <van-calendar v-model="show" type="range" @confirm="onConfirm" />
  </div>
</template>

<script>
const OrderShopStatus = {
  INIT: { title: "未接单", percentage: 0 },
  RECEIVED: { title: "已接单", percentage: 30 },
  PROCESSING: { title: "制作中", percentage: 50 },
  FINISH: { title: "已完成", percentage: 100 },
};
const OrderDelivererStatus = {
  INIT: { title: "未接单", percentage: 0 },
  RECEIVED: { title: "已接单", percentage: 30 },
  DISPATCH: { title: "已取餐", percentage: 50 },
  FINISH: { title: "已完成", percentage: 100 },
};
const OrderGeneralStatus = {
  INIT: { title: "未开始", percentage: 0 },
  PROCESSING: { title: "进行中", percentage: 30 },
  FINISH: { title: "完成订单", percentage: 50 },
  CANCEL: { title: "已取消", percentage: 100 },
};
const wx = window["wx"];
import {
  getwxgzhConfig,
  categoryList,
  orderList,
  orderdetail,
  orderscan,
  orderCancel,
  orderBind,
  orderToReceived,
  orderToFinish,
  categoryScan,
} from "../../apis/scy";
import { Toast } from "vant";
import _ from "lodash";
export default {
  data() {
    return {
      shopId: 1241,
      orderNo: "",
      timeActive: 0,
      typeActive: "CURRENT",
      orderDetailShow: false,
      areaDetailShow: false,
      categoryList: [],
      getData: {
        lastId: "",
        type: "HISTORY",
      },
      loading: false,
      finished: false,
      orderList: [],
      errOrderTotal: 0,
      OrderTotal: 0,
      orderDetail: {},
      oneKeyConTitle: "",
      show: false,
      date: "筛选时间",
    };
  },
  mounted() {
    setTimeout(() => {
      this.WXConfigFun();
    }, 400);
    this.categoryListFun();
  },
  filters: {
    OrderDelivererStatusFilter(val) {
      return OrderDelivererStatus[val].title;
    },
    OrderGeneralStatusFilter(val) {
      return OrderGeneralStatus[val].title;
    },
    OrderShopStatusFilter(val) {
      return OrderShopStatus[val].title;
    },
  },
  methods: {
    // 手动接单
    orderToStatus(item, toStatus) {
      let obj = {
        shopId: this.shopId,
        orderNo: item.orderNo,
        toStatus,
      };
      orderBind(obj).then((res) => {
        if (res.data.code == 200) {
          Toast("接单成功");
        } else {
          Toast(res.data.message);
        }
        this.refresh();
      });
    },
    // 接单接口
    orderToReceived(orders, isAll) {
      orderToReceived(orders, isAll).then(({ data }) => {
        if (data.code === 200) {
          this.refresh();
        } else {
          Toast(data.message);
        }
      });
    },
    // 送达接口
    orderToFinish(orders) {
      orderToFinish(orders).then(({ data }) => {
        if (data.code === 200) {
          this.refresh();
        } else {
          Toast(data.message);
        }
      });
    },
    // 获取负责区域
    categoryListFun() {
      categoryList(this.shopId).then((res) => {
        this.categoryList = res.data.data || [];
      });
    },
    async orderDetailFun() {
      let { data: res } = await orderdetail({
        shopId: this.shopId,
        orderNo: this.orderNo,
      });
      if (res.code != 200) {
        Toast(res.message);
        return;
      }
      this.orderDetail = res.data;
      let status = this.orderDetail.status;
      status == "PUBLISHED" ? this.orderscanFun("DISPATCH") : ""; //取餐
      status == "DISPATCH" ? this.orderscanFun("FINISHED") : ""; //核销
      this.oneKeyConTitle = this.getObjectKey(status);
      this.orderDetailShow = true;
    },
    // 重新获取列表
    refresh() {
      this.$refs.listout.scrollTop = 0;
      this.orderList = [];
      this.loading = false;
      this.finished = false;
      this.$refs.orderListRef.check();
    },
    // 切换tab
    async OrderTabChange() {
      this.refresh();
    },
    // 获取订单
    async OrderListFun() {
      var req = {
        lastId: _.last(this.orderList).id,
        shopId: this.shopId,
        type: this.typeActive,
      };
      if (this.typeActive === "HISTORY") {
        req.startTargetDay = this.getData.startTargetDay;
        req.endTargetDay = this.getData.createTimeEnd;
      }
      const { data: resData } = await orderList(req);
      const { hasMore, content } = resData.data;
      this.loading = false;
      this.finished = !hasMore;
      this.orderList = _.concat(this.orderList, content);
    },
    orderscanFun(status) {
      orderscan({
        orderNo: this.orderNo,
        status: status,
        shopId: this.shopId,
      });
    },
    QRFun() {
      let that = this;
      wx.scanQRCode({
        onlyFromCamera: true,
        needResult: 1,
        scanType: ["qrCode"],
        success: function (res) {
          this.orderNo = res.resultStr;
          that.orderDetailFun();
        },
      });
    },
    XZQRFun() {
      let that = this;
      // categoryScan
      wx.scanQRCode({
        onlyFromCamera: true,
        needResult: 1,
        scanType: ["qrCode"],
        success: function (res) {
          console.log(res);
          let url = res.resultStr;
          let bedId = that.getQueryString(url, "bedId");
          categoryScan({
            shopId: that.shopId,
            bedId,
          }).then((res) => {
            console.log(res, 362);
            that.goDish(res.data.data);
          });
        },
      });
    },

    async WXConfigFun() {
      let url = window.location.href.split("#")[0];
      const { data: data } = await getwxgzhConfig({
        url,
      });
      this.config = {
        debug: false, // 调试模式,调用api返回值会在客户端alert出来，参数信息会通过log打出pc端时才会打印
        appId: data.data.appid, // 必填，公众号的唯一标识
        timestamp: data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.data.noncestr, // 必填，生成签名的随机串
        signature: data.data.signature, // 必填，签名
        jsApiList: ["checkJsApi", "scanQRCode"],
      };
      wx.config(this.config);
      wx.ready(function () {
        console.log("ready"); //需在用户可能点击分享按钮前就先调用
      });
      wx.checkJsApi({
        jsApiList: ["scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
        },
      });
      wx.error(function (res) {
        console.log(res, "wx.error");
      });
    },
    async onRefresh() {
      this.getData = { lastId: 0, type: "history" };
      this.date = "筛选时间";
      this.orderList = await this.OrderListFun();
      Toast("刷新成功");
      this.isLoading = false;
    },
    async onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start).slice(0, 10)} - ${this.formatDate(
        end
      ).slice(0, 10)}`;
      this.getData.startTargetDay = this.formatDate(start);
      this.getData.createTimeEnd = this.formatDate(end);
      // this.orderList = await this.OrderListFun();
      this.refresh();
    },
    gopage(path) {
      this.$router.push(path);
    },
    goDish(item) {
      console.log(item, 417);
      this.$router.push({
        path: "/Dish",
        query: {
          order: JSON.stringify(item),
        },
      });
    },
    formatDate(date) {
      let timeStr = date.getFullYear() + "-";
      if (date.getMonth() < 9) {
        timeStr += "0";
      }
      timeStr += date.getMonth() + 1 + "-";
      timeStr += date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      timeStr += " ";
      timeStr += date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      timeStr += ":";
      timeStr +=
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      timeStr += ":";
      timeStr +=
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return timeStr;
    },
    getObjectKey(value) {
      let object = {
        INIT: "初始订单", // 系统生成订单
        WAIT_PAY: "待支付订单", // 用户未支付
        PAID: "已支付订单", //用户支付
        RECEIVED: "已接单订单", // 食堂接单
        PUBLISHED: "取餐成功", // 允许送餐员第一次扫码 已发布
        DISPATCH: "核销成功", // 允许送餐员第二次扫码 送餐中
        FINISHED: "已完成订单",
      };
      return object[Object.keys(object).find((key) => key == value)];
    },
    getQueryString(url, name) {
      console.log(url, 178);
      url = decodeURIComponent(url);
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return results[2].replace(/\+/g, " ");
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-overlay {
  z-index: 10;
}
.content-buts {
  margin-top: 10px;
  margin-bottom: -14px;
  ::v-deep .van-tabs {
    width: 100%;
    height: 100%;
  }
  ::v-deep .van-tabs__line {
    display: none;
  }
  ::v-deep .van-tab {
    font-size: 17px;
    font-weight: 400;
    color: #b5d8d8;
  }
  ::v-deep .van-tab--active {
    font-size: 17px;
    font-weight: bold;
    color: #4bd8d8;
    z-index: 10;
  }
  ::v-deep .van-tabs__nav {
    background: none;
  }
}
.mealtime {
  ::v-deep .van-tabs {
    width: 256px;
    height: 90%;
    background: #f7f8fa;
    border-radius: 57px 57px 57px 57px;
  }
  ::v-deep .van-tabs__line {
    display: none;
  }
  ::v-deep .van-tab {
    font-size: 14px;
    font-weight: 400;
    color: #b5d8d8;
  }
  ::v-deep .van-tab--active {
    font-size: 17px;
    font-weight: bold;
    background: #4bd8d8;
    border-radius: 57px 57px 57px 57px;
    color: #fff;
    z-index: 10;
  }
  ::v-deep .van-tabs__nav {
    background: none;
  }
}
</style>
<style lang="less" scoped>
* {
  font-size: 15px;
  font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC", serif;
}
.page {
  background: #fff;
  z-index: 20;
  min-height: 100vh;
}
.flex {
  display: flex;
}
.BothSidesAreAligned {
  justify-content: space-between;
}
.badge {
  position: absolute;
  top: 5px;
  right: -3px;
}
.header {
  padding: 20px;
  background: #f7f8fa;
  &-icon {
    position: relative;
    top: 4px;
  }
  &-territory {
    width: 72px;
    height: 28px;
    line-height: 28px;
    background: rgba(75, 216, 216, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-weight: 500;
    color: #4bd8d8;
    text-align: center;
  }
}
.topBtns {
  margin: 10px 0;
  width: 156px;
  height: 64px;
  border-radius: 8px 8px 8px 8px;
  padding: 12px;
  box-sizing: border-box;
  color: #ffffff;
  img {
    width: 32px;
    height: 32px;
    text-align: center;
    margin-top: 8px;
  }
  &-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 25px;
  }
  &-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 25px;
  }
}
.QRscan {
  background: #4bd8d8;
}
.DishBtn {
  background: #ffbe5c;
}
.orderNum {
  min-width: 50px;
  font-size: 17px;
  font-weight: 500;
  color: #4bd8d8;
}
.acceptOrCancel {
  font-size: 0.4rem;
  font-weight: 500;
  color: #4bd8d8;
  font-size: 0.4rem;
  font-weight: 500;
  margin-left: 6px;
}
.content {
  width: 375px;
  box-shadow: 0px -2px 6px 1px rgba(75, 216, 216, 0.1);
  border-radius: 12px 12px 0 0;
  padding: 20px;
  box-sizing: border-box;
  line-height: 52px;
  &-title {
    font-size: 17px;
    font-weight: 400;
    color: #202020;
  }
  &-con {
    margin: 5px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #dcdee0;
  }
}
.oneKeyCon {
  width: 324px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  &-Title {
    font-size: 17px;
    font-weight: 500;
    color: #202020;
    text-align: center;
    line-height: 60px;
  }
  &-Con {
    font-size: 14px;
    font-weight: 400;
    color: #606060;
    line-height: 21px;
    width: 90%;
    margin: 20px auto 0;
    height: 200px;
    overflow-y: scroll;
    &-item > div:nth-child(2) {
      font-size: 15px;
      color: #202020;
    }
  }
  &-Con > div {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #f0f2f5;
  }
}
.Order-List {
  &-Item {
    padding: 10px;
    line-height: 25px;
    box-sizing: border-box;
  }
  &-ReceiveO {
    font-weight: bold;
    color: #4bd8d8;
    line-height: 50px;
    min-width: 1rem;
  }
  &-cancelO {
    font-weight: 400;
    color: #f26161;
    line-height: 50px;
  }
  &-cancelT {
    font-weight: 400;
    color: #4bd891;
    line-height: 50px;
  }
}
.Order-List > div:nth-child(2n-1) {
  background: #f7fcfc;
  border-radius: 8px 8px 8px 8px;
}
.overlay-Buts {
  &-Over {
    font-size: 17px;
    font-weight: 500;
    color: #94b0b0;
    line-height: 50px;
    text-align: center;
  }
}
.refundedimg {
  position: absolute;
  right: 20px;
  bottom: 70px;
}
.OrderSearch {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  &-Time {
    width: 100%;
  }
  &-timeSearch {
    height: 32px;
    background: #e9e9e9;
    border-radius: 8px 8px 8px 8px;
    font-size: 14px;
    font-weight: 400;
    color: #b0b0b0;
    line-height: 32px;
    padding-left: 10px;
    box-sizing: border-box;
  }
}
</style>
